// One definition of who can see or manage clients. Views and the store both
// read these getters so a permission change does not have to be copied.
export const clientPermissionGetters = {
  hasPermissionToManageClients: (state) => () => {
    return state.permissions.includes("admin:manage:clients");
  },
  hasPermissionToViewClients: (state) => () => {
    return (
      state.permissions.includes("admin:read:clients") ||
      state.permissions.includes("admin:manage:clients")
    );
  },
};
